/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';

const Invoices = () => {
  return (
    <div className="invoices-container">
      <h2>Invoices</h2>
      {/* Content will be added later */}
    </div>
  );
};

export default Invoices;
